module.exports = __webpack_public_path__ + "static/img/welcome.51c7626b.jpg";